import { ExportTypeBaseService } from '/@/modules/export/services/ExportTypeBaseService';
import { getters } from '/@/modules/core/app/helpers/store';
import Lang from '/@/modules/core/app/services/Lang';

export class EstateDistributionPlanExportService extends ExportTypeBaseService {
  /**
   * @var {Estate}
   */
  estate;

  /**
   * @return {string}
   */
  getFilename() {
    this.estate = getters.export.getData().estate;
    return `${this.estate.contact.fullName.replaceAll(' ', '-')}-distribution-plan.pdf`;
  }

  /**
   * @return {string}
   */
  getSnackBarTitle() {
    this.estate = getters.export.getData().estate;
    return Lang.t("estatedistribution.distribution-plan-now", {
      name: this.estate.contact.fullName
    });
  }
}

export default new EstateDistributionPlanExportService();
